/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface FlightExchangeConfirmationRequest
 */
export interface FlightExchangeConfirmationRequest {
  /**
   *
   * @type {boolean}
   * @memberof FlightExchangeConfirmationRequest
   */
  confirmed: boolean;
}

/**
 * Check if a given object implements the FlightExchangeConfirmationRequest interface.
 */
export function instanceOfFlightExchangeConfirmationRequest(
  value: object
): value is FlightExchangeConfirmationRequest {
  if (!("confirmed" in value) || value["confirmed"] === undefined) return false;
  return true;
}

export function FlightExchangeConfirmationRequestFromJSON(
  json: any
): FlightExchangeConfirmationRequest {
  return FlightExchangeConfirmationRequestFromJSONTyped(json, false);
}

export function FlightExchangeConfirmationRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FlightExchangeConfirmationRequest {
  if (json == null) {
    return json;
  }
  return {
    confirmed: json["confirmed"],
  };
}

export function FlightExchangeConfirmationRequestToJSON(
  json: any
): FlightExchangeConfirmationRequest {
  return FlightExchangeConfirmationRequestToJSONTyped(json, false);
}

export function FlightExchangeConfirmationRequestToJSONTyped(
  value?: FlightExchangeConfirmationRequest | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    confirmed: value["confirmed"],
  };
}
